import { Button, Robot } from '@cimpress/react-components';
import { IconAlertTriangle } from '@cimpress-technology/react-streamline-icons';
import styles from '../css/errors.module.scss';
import { useCallback } from 'react';

export interface ErrorStateComponentProps {
  message?: string;
  description?: string;
}

//Considering on Internal Server Error for now
//This component can be extended to handle other error states in the future.
const DEFAULT_DESCRIPTION =
  'An issue occurred on our servers. \n Please try again later or contact support';
const DEFAULT_MESSAGE = 'Internal Server Error';

const ErrorStateComponent = ({
  description = DEFAULT_DESCRIPTION,
  message = DEFAULT_MESSAGE,
}: ErrorStateComponentProps) => {
  const formattedDescription = description.split('\n').map((line, i, arr) => (
    <span key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </span>
  ));

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  const handleContactSupport = useCallback(() => {
    const supportUrl = 'https://cimpress.slack.com/archives/C081NEM06KH';
    window.open(supportUrl, '_blank'); // Open in a new tab
  }, []);

  return (
    <div className={styles.fallbackComponent}>
      <Robot status="danger" className="robot" />
      <div className={styles.alert}>
        <IconAlertTriangle className={styles.icon} weight="fill" />
        <h2 className={styles.message}>{message}</h2>
      </div>
      {formattedDescription}
      <div className={styles.buttonContainer}>
        <Button variant="primary" onClick={handleRetry}>
          Retry
        </Button>
        <Button variant="default" onClick={handleContactSupport}>
          Contact Support
        </Button>
      </div>
    </div>
  );
};

export default ErrorStateComponent;
